const mutations = {
  /* eslint-disable no-param-reassign */
  SET_TOKEN(state, payload) {
    state.token = payload;
  },

  SET_USER(state, payload) {
    state.user = payload;
  },

  SET_USER_EMAIL(state, payload) {
    state.userEmail = payload;
  },

  SET_PUBLIC_PAGES(state, payload) {
    state.publicPages = payload;
  },

  SET_EMAIL_SUCCESS(state, payload) {
    state.emailSuccess = payload;
  },

  SET_MENU_ABERTO(state, payload) {
    state.menuAberto = payload;
  },

  SET_DADOS_COMPRA(state, payload) {
    state.dadosCompra = payload;
  },

  SET_DADOS_TRANSACAO(state, payload) {
    state.dadosTransacao = payload;
  },

  SET_MOTIVOS_REEMBOLSO(state, payload) {
    state.motivosReembolso = payload;
  },

  SET_URL_ANTES_LOGIN(state, payload) {
    state.urlAntesLogin = payload;
  },

  SET_ASSINATURA_CANCELADA(state, payload) {
    state.assinaturaCancelada = payload;
  },

  SET_CONCORDOU_COM_VENDEDOR(state, payload) {
    state.concordouComVendedor = payload;
  },

  SET_REFRESHING_TOKEN_PROMISE(state, payload) {
    state.refreshingTokenPromise = payload;
  },

  SET_ALTERAR_DADOS_BANCARIOS(state, payload) {
    state.alterarDadosBancarios = payload;
  },

  SET_ALTERAR_ALERTA_FORMA_PAGAMENTO(state, payload) {
    state.alertaFormaPagamento = payload;
  },

  SET_RELOAD_PAGE(state, payload) {
    state.reloadPage = payload;
  },

  SET_MENU_LATERAL(state, payload) {
    state.menuLateral = payload;
  },

  SET_AFILIADO_PRODUTOR(state, payload) {
    state.afiliadoProdutor = payload;
  },

  SET_RASTREIO(state, payload) {
    state.rastreio = payload;
  },

  /* eslint-enable no-param-reassign */
};

export default {
  mutations,
};
